module.exports = __webpack_public_path__ + "img/collection-engagementRingsUsa@2x.3214a89.jpg";